import { Menu, Tooltip } from '@mantine/core';
import { IconUserCheck } from '@tabler/icons-react';
import ActionIcon from 'components/ActionIcon';
import Button from 'components/Button';
import { useConfirm } from 'components/modals/message/MessageProvider';
import useAssignToSelfAction from 'components/tables/data/revision/actions/hooks/use-assign-to-self-action';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { noop } from 'lodash';

/**
 * Action that assigns an unassigned revision or form to the current user.
 */
export default function AssignToSelfAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { assignToSelf } = useAssignToSelfAction();
  const { confirm } = useConfirm();

  /** Opens the self-assignment confirmation dialog. */
  const confirmAssignment = () =>
    confirm({
      title: revision.kind === 'revision' ? 'Prideliť revíznu správu mne' : 'Prideliť formulár mne',
      content:
        revision.kind === 'revision'
          ? 'Naozaj si prajete prideliť túto revíznu správu sebe?'
          : 'Naozaj si prajete prideliť tento formulár sebe?',
      onConfirm: () => assignToSelf({ revision, onStatusChange }),
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Prideliť mne" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="primary" size="md" onClick={confirmAssignment}>
          <IconUserCheck />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button variant="primary" size="md" onClick={confirmAssignment} leftIcon={<IconUserCheck />} w={188}>
        Prideliť mne
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={confirmAssignment} icon={<IconUserCheck stroke={1.5} size={20} />}>
      Prideliť mne
    </Menu.Item>
  );
}
